import { defineStore } from "pinia";
import { useMediaQuery } from "@vueuse/core";
import { useRouter, useRoute } from "vue-router";
import {
	getLocalStorageReac,
	simpleCrypt,
	simpleDecrypt,
} from "@/assets/js/helpers";
import type { TCurrency, TRouteName } from "@/assets/js/globalTypes";
import api from "@/api";
import type { TMenu } from "@/components/shared/menu/ModernSideMenu2.vue";
import type { FunctionalComponent, SVGAttributes } from "vue";

export const useDefaultStore = defineStore("main", () => {
	// const { width } = useWindowSize();
	const isMobileToggled = ref(false);
	const router = useRouter();
	const route = useRoute();
	const currentLocale = getLocalStorageReac("lang");

	const getLanguage = computed<string>(
		() => (currentLocale.value as string) || "fr",
	);

	const settings = ref<{
		currency: TCurrency;
		contact_support_email: string;
	}>();

	const currencySymbol = computed(() => {
		return settings.value?.currency.symbol || "€";
	});

	const currencyIso = computed(() => {
		return settings.value?.currency.cc || "EUR";
	});

	const supportEmail = computed(() => {
		return settings.value?.contact_support_email || "";
	});

	// const isMobileSize = computed(() => width.value < 768);
	// const isMobileSize = computed(() => {
	// 	console.log(width.value);
	// 	return 0;
	// });
	const isMobileSize = useMediaQuery("(max-width: 768px)");
	const isMobileView = computed(
		() => isMobileSize.value && isMobileToggled.value,
	);

	watch(isMobileSize, (val) => {
		if (!val) {
			isMobileToggled.value = false;
		}
	});

	function decodePath(name: string) {
		return simpleDecrypt("abc", name);
	}
	function encodePath(name: string) {
		return simpleCrypt("abc", name);
	}
	async function onClickLoginPage() {
		// Used to return user to the previous page
		const currentPageName = String(route.name);

		// Exceptions - Auth pages
		let ppn: string | undefined = encodePath(currentPageName);
		if (
			route.matched.some((rt) => rt.name === "auth" || rt.name === "base.home")
		) {
			ppn = undefined;
		}

		await router.push({
			name: "auth.login",
			query: {
				ppn,
			},
		});
	}

	async function goToProfilePage() {
		await router.push({
			// name: "SettingsPage",
			// name: "ProfilePage",
			name: "auth.login",
		});
	}

	async function setupSettings() {
		const res = await api.getSettings();
		settings.value = res.data.data;
	}

	const setActiveStep = (routeName: string, menuItems: TMenu[]) => {
		for (const [index, menu] of menuItems.entries()) {
			if (
				menu.heading.route === routeName ||
				menu.items.some((item) => item.name === routeName)
			) {
				return index + 1;
			}
		}
	};

	function getFirstLetter(str: string): string {
		if (typeof str !== "string" || str.trim() === "") {
			return "";
		}
		return str.trim().charAt(0);
	}

	function getIconByRouteName(
		routeName: TRouteName,
		menuItems: TMenu[],
	): FunctionalComponent<SVGAttributes> | null | null {
		for (const menu of menuItems) {
			if (menu.items.length !== 0) {
				for (const item of menu.items) {
					if (item.name === routeName) {
						return item.icon;
					}
				}
			}
		}

		return null;
	}

	return {
		isMobileSize,
		isMobileToggled,
		isMobileView,
		decodePath,
		encodePath,
		onClickLoginPage,
		goToProfilePage,
		setupSettings,
		currencySymbol,
		currencyIso,
		setActiveStep,
		getFirstLetter,
		getIconByRouteName,
		supportEmail,
		currentLocale,
		getLanguage,
	};
});
